import { render, staticRenderFns } from "./ReservationListWidget.vue?vue&type=template&id=7458e9d4&scoped=true&"
import script from "./ReservationListWidget.vue?vue&type=script&lang=ts&"
export * from "./ReservationListWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7458e9d4",
  null
  
)

export default component.exports